import React from 'react';

import Logo from '../img/logo.png';

class Title extends React.Component {
    
    render(){
    
       return (
         <React.Fragment>
          <div className="stuffHeader-titlecontainer">
            <img className="stuffHeader-titlecontainer--logo" src={Logo} alt="the whole truth logo"/>
            <div className="stuffHeader-titlecontainer--introbox">
                <p className="stuffHeader-titlecontainer--introbox---text">
                While they're vying for votes, politicians will tell all sorts of tales to win favour. Sometimes, they'll lie.
                </p>
                <p className="stuffHeader-titlecontainer--introbox---text">
                More often, they'll tell just one part of the story. The part that shows them in the best possible light.
                </p>
                <p className="stuffHeader-titlecontainer--introbox---text">
                They're salespeople trying to close a deal. The stuff that makes them look great, they'll crow about. The bits that are less flattering, they'll avoid.
                </p>
                <p className="stuffHeader-titlecontainer--introbox---text">
                It's our job to fill in the gaps for you.
                </p>
                <p className="stuffHeader-titlecontainer--introbox---text">
                In the six weeks leading up to election day, we're delivering The Whole Truth of the campaign.
                </p>
                <p className="stuffHeader-titlecontainer--introbox---text">
                We tackle the big debates and key issues, giving a full and clear account of each without all the noise of the raucous daily news cycle. And sometimes, the Whole Truth exposes the lies of those who would be your representative in Parliament.
                </p>
            </div>
          </div>
          </React.Fragment>
       );
    }
}

export default Title;